import type { SpecificationStreamContent, SpecificationStreamProvider } from '../types/specification';
import type { SpecificationConfirmDisclosurePayload } from '../types/specification-confirm-disclosure';

export const SpecificationConfirmDisclosureRepository = Symbol.for('SpecificationConfirmDisclosureRepository');

export interface SpecificationConfirmDisclosureRepository {
    /** 生成分类号 */
    genClassification(taskId: string, regenerate?: boolean): SpecificationStreamProvider<SpecificationStreamContent<string[]>>;

    /** 生成技术类型 */
    genStatutoryCategory(taskId: string, regenerate?: boolean): SpecificationStreamProvider<SpecificationStreamContent<string>>;

    /**
     * 生成技术问题、技术手段、技术功效
     */
    genTechnical(taskId: string, regenerate?: boolean): SpecificationStreamProvider<SpecificationStreamContent<{
        technical_problem: string;
        technical_methods: string;
        benefit: string;
    }>>;

    /**
     * 生成实施例
     */
    genEmbodiment(taskId: string, regenerate?: boolean): SpecificationStreamProvider<SpecificationStreamContent<{
        text: string;
        selected: boolean;
    }[]>>;

    /**
     * 提交
     */
    submit(taskId: string, payload: SpecificationConfirmDisclosurePayload): Promise<void>;
}
